import { render, staticRenderFns } from "./Trooperz.vue?vue&type=template&id=666356a6&"
import script from "./Trooperz.vue?vue&type=script&lang=ts&"
export * from "./Trooperz.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports